exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".userContainer{position:absolute;top:0;bottom:0;left:0;right:0;background:#fff;padding:20px}.signinSignup{display:flex;flex-direction:column}.userHeader{margin-bottom:0}.userHeader>div{display:flex;float:right}.userHeader>div i{font-size:10px}.userHeader>div p{font-size:12px;text-transform:uppercase;margin-bottom:0}.currentUser_logout{display:block;border:none;background:none;color:#333;padding:0;margin:0 0 0 1em;font-size:12px;cursor:pointer}.currentUser_logout:hover{color:red}.fb-login-button{margin:1em 0 0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/user/user.scss
// module id = 539
// module chunks = 0